/* eslint-disable prefer-destructuring */
const blockUser = async (manageConfig, pIsActive) => {
  const { apiBaseUrl, eventShort, accessToken } = manageConfig;
  const isActive = pIsActive;
  const { userAgent } = navigator;

  if (!isActive) throw new Error('Module is not active');
  if (!accessToken) throw new Error('Access token is missing');
  // Function to determine the device type
  const getDeviceType = (ua) => {
    if (/iPhone/.test(ua)) {
      return 'iPhone';
    } if (/iPad/.test(ua)) {
      return 'iPad';
    } if (/iPod/.test(ua)) {
      return 'iPod';
    } if (/Android/.test(ua) && !/Mobile/.test(ua)) {
      return 'Android Tablet';
    } if (/Android/.test(ua)) {
      return 'Android Phone';
    } if (/Windows Phone/.test(ua)) {
      return 'Windows Phone';
    } if (/Macintosh/.test(ua)) {
      return 'Mac';
    } if (/Windows/.test(ua)) {
      return 'Windows PC';
    } if (/Linux/.test(ua)) {
      return 'Linux PC';
    }
    return 'Other';
  };

  const getBrowserInfo = (ua) => {
    let browserName = 'Unknown';
    let fullVersion = 'Unknown';

    // Add debug logging for iOS Chrome
    console.log('Full User Agent:', ua);

    // iOS Chrome specific detection (CriOS)
    const iosChromeMatch = ua.match(/CriOS\/(\S+)/);
    const chromeMatch = ua.match(/Chrome\/(\S+)/);
    const safariMatch = ua.match(/Version\/(\S+)/);
    const firefoxMatch = ua.match(/Firefox\/(\S+)/);
    const ieMatch = ua.match(/MSIE (\d+\.\d+);/);
    const tridentMatch = ua.match(/Trident\/.*rv:(\d+\.\d+)/);
    const edgeMatch = ua.match(/Edg\/(\S+)/);
    const operaMatch = ua.match(/Opera\/(\S+)/);
    const oprMatch = ua.match(/OPR\/(\S+)/);

    if (iosChromeMatch) {
      browserName = 'Chrome';
      fullVersion = iosChromeMatch[1];
    } else if (chromeMatch) {
      browserName = 'Chrome';
      fullVersion = chromeMatch[1];
    } else if (safariMatch && !/Chrome/.test(ua) && !/CriOS/.test(ua)) {
      browserName = 'Safari';
      fullVersion = safariMatch[1];
    } else if (firefoxMatch) {
      browserName = 'Firefox';
      fullVersion = firefoxMatch[1];
    } else if (ieMatch) {
      browserName = 'Internet Explorer';
      fullVersion = ieMatch[1];
    } else if (tridentMatch) {
      browserName = 'Internet Explorer';
      fullVersion = tridentMatch[1];
    } else if (edgeMatch) {
      browserName = 'Microsoft Edge';
      fullVersion = edgeMatch[1];
    } else if (operaMatch) {
      browserName = 'Opera';
      fullVersion = operaMatch[1];
    } else if (oprMatch) {
      browserName = 'Opera';
      fullVersion = oprMatch[1];
    }

    console.log('Detected browser:', browserName, 'version:', fullVersion);

    return {
      name: browserName,
      version: fullVersion
    };
  };
  console.log(68, userAgent);

  const deviceType = getDeviceType(userAgent);
  console.log(71, deviceType);

  const browserNameAndVersion = `${getBrowserInfo(userAgent).name}${getBrowserInfo(userAgent).version}`;
  console.log(74, browserNameAndVersion);

  const url = `${apiBaseUrl}/api/User/BlockUser?shortname=${eventShort}&device=${deviceType}&browser=${browserNameAndVersion}`;
  console.log(url);
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
  console.log(response);

  if (response?.status === 200) {
    return response.data;
  }
  return null;
};

export { blockUser };
